import {
  abi as stakeHaveBooster,
  bytecode as stakeHaveBoosterBytecode,
} from "../../contracts/StakeV2.1.sol/StakeV2.json";
import { abi } from "../../contracts/StakeV2.sol/StakeV2.json";
import { abi as oldAbi } from "../../contracts/StakeHasFee.sol/StakeHasFee.json";
import { abi as erc20Abi } from "../../contracts/ERC20Mock.json";
import { Contract, ContractFactory, ethers } from "ethers";
import { chainOptions } from "const";

// const chainPrc = process.env.REACT_APP_CHAIN_PRC;

const chainRpcList = [
  { name: "Amoy", chainId: "80002", url: "https://polygon-amoy.drpc.org" },
  { name: "Cronos", chainId: "25", url: "https://cronos.drpc.org" },
  { name: "Polygon", chainId: "137", url: "https://polygon-bor-rpc.publicnode.com" },
  { name: "Binance", chainId: "56", url: "https://binance.llamarpc.com" },
  { name: "Base", chainId: "8453", url: "https://base.llamarpc.com" },
  { name: "Blast", chainId: "81457", url: "https://rpc.envelop.is/blast" },
];

const getStakeFeeAddress = async () => {
  if (!window.ethereum) return;
  const { ethereum } = window;
  const provider = new ethers.providers.Web3Provider(ethereum);
  const { chainId } = await provider.getNetwork();
  return chainOptions().find((c) => +c.value === +chainId)?.config?.stakeFeeAddress;
};

export async function deploy(signer, { coinAddress, collections, ratio, booster, boosterRatio }) {
  const factory = new ContractFactory(stakeHaveBooster, stakeHaveBoosterBytecode, signer);
  const stakeFeeAddress = await getStakeFeeAddress();
  if (!stakeFeeAddress) {
    alert("stakeFeeAddress is not set");
    return;
  }
  // if (!process.env.REACT_APP_STAKE_FEE_ADDRESS) {
  //   alert("Please set REACT_APP_STAKE_FEE_ADDRESS");
  //   return;
  // }

  const contract = await factory.deploy(
    coinAddress,
    collections,
    ratio,
    booster || ethers.constants.AddressZero,
    boosterRatio * 100,
    stakeFeeAddress,
  );

  return {
    transaction: contract.deployTransaction,
    data: { address: contract.address },
  };
}

export function getStakingContract(address, signer) {
  return new Contract(address, abi, signer);
}

export async function claimFeeOld(signer, { stakingAddress }) {
  const stakeContract = new Contract(stakingAddress, oldAbi, signer);
  const tx = await stakeContract.claimChargeFee();
  return {
    transaction: tx,
    data: {},
  };
}

export async function claimFee(signer, { stakingAddress }) {
  const stakeContract = new Contract(stakingAddress, abi, signer);
  const tx = await stakeContract.claimChargeFee();
  return {
    transaction: tx,
    data: {},
  };
}

export async function formatErc20(address, value, url) {
  const provider = new ethers.providers.JsonRpcProvider(url);
  const contract = new Contract(address, erc20Abi, provider);
  const decimals = await contract.decimals();
  return ethers.utils.formatUnits(value, decimals);
}

export async function approveErc20(signer, { poolAddress, coinAddress, amount }) {
  const contract = new Contract(coinAddress, erc20Abi, signer);
  const tx = await contract.approve(poolAddress, amount);
  return {
    transaction: tx,
    data: {},
  };
}

export async function getRewardDetail(address, chainId) {
  const chain = chainRpcList.find((item) => +item.chainId === +chainId);
  const provider = new ethers.providers.JsonRpcProvider(chain.url);
  const contract = new Contract(address, abi, provider);
  const rewardRate = await contract.rewardRate();
  const duration = await contract.rewardsDuration();
  const rewardsToken = await contract.rewardsToken();
  const paused = await contract.paused();

  return {
    rewardPerWeek: +(await formatErc20(rewardsToken, rewardRate.mul(60 * 60 * 24 * 7), chain.url)),
    weeks: +duration / (60 * 60 * 24 * 7),
    periodFinish: +(await contract.periodFinish()),
    paused,
  };
}
